import React, { useMemo } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useLanguage } from '../../../../contexts/LanguageContext';

const PRIMARY_BLUE = '#0B3187';
const SUCCESS_COLOR = '#16a34a';
const ERROR_COLOR = '#E30613';
const SUCCESS_BG = '#f0fdf4';
const ERROR_BG = '#fff1f2';

const BulkResultDialog = ({ visible, data, onHide, type }) => {
    const { th } = useLanguage();

    const entries = useMemo(
        () => (data && typeof data === 'object' ? Object.entries(data) : []),
        [data]
    );

    const successLabel = th('pendingApprovalRequests.bulkSuccess');

    const successCount = useMemo(
        () => entries.filter(([, msg]) => (msg || '').trim().toLowerCase() === successLabel.toLowerCase()).length,
        [entries, successLabel]
    );
    const errorCount = entries.length - successCount;

    const title =
        type === 'return'
            ? th('pendingApprovalRequests.bulkResultTitleReturn')
            : th('pendingApprovalRequests.bulkResultTitleAccept');

    const dialogHeader = (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
            <span
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '2rem',
                    height: '2rem',
                    borderRadius: '50%',
                    background: PRIMARY_BLUE,
                    flexShrink: 0
                }}
            >
                <i className="pi pi-list" style={{ color: '#fff', fontSize: '0.9rem' }} />
            </span>
            <span style={{ fontSize: '1rem', fontWeight: 700, color: PRIMARY_BLUE }}>{title}</span>
        </div>
    );

    return (
        <Dialog
            visible={visible}
            header={dialogHeader}
            style={{ width: '26rem', borderRadius: '0.75rem' }}
            onHide={onHide}
            modal
            closable
            draggable={false}
            resizable={false}
            footer={
                <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '0.25rem' }}>
                    <Button
                        label={th('common.close')}
                        icon="pi pi-times"
                        onClick={onHide}
                        style={{ background: PRIMARY_BLUE, border: 'none', borderRadius: '0.4rem' }}
                    />
                </div>
            }
        >
            {/* Özet bant */}
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '1rem',
                    marginBottom: '1.1rem',
                    padding: '0.65rem 0.85rem',
                    borderRadius: '0.5rem',
                    background: '#f1f5fb',
                    border: '1px solid #d4dff5'
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                    <i className="pi pi-check-circle" style={{ color: SUCCESS_COLOR, fontSize: '1.05rem', lineHeight: 1 }} />
                    <span style={{ fontWeight: 600, color: SUCCESS_COLOR, fontSize: '0.92rem', lineHeight: 1 }}>
                        {successCount} {th('pendingApprovalRequests.bulkSuccess')}
                    </span>
                </div>
                {errorCount > 0 && (
                    <>
                        <span style={{ color: '#cbd5e1' }}>|</span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                            <i className="pi pi-times-circle" style={{ color: ERROR_COLOR, fontSize: '1.05rem', lineHeight: 1 }} />
                            <span style={{ fontWeight: 600, color: ERROR_COLOR, fontSize: '0.92rem', lineHeight: 1 }}>
                                {errorCount} {th('pendingApprovalRequests.bulkError')}
                            </span>
                        </div>
                    </>
                )}
            </div>

            {/* Satır listesi */}
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                {entries.map(([id, message]) => {
                    const isSuccess = (message || '').trim().toLowerCase() === successLabel.toLowerCase();
                    return (
                        <li
                            key={id}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.65rem',
                                padding: '0.55rem 0.75rem',
                                borderRadius: '0.45rem',
                                background: isSuccess ? SUCCESS_BG : ERROR_BG,
                                border: `1px solid ${isSuccess ? '#bbf7d0' : '#fecdd3'}`
                            }}
                        >
                            <i
                                className={`pi ${isSuccess ? 'pi-check-circle' : 'pi-times-circle'}`}
                                style={{
                                    fontSize: '1.05rem',
                                    flexShrink: 0,
                                    color: isSuccess ? SUCCESS_COLOR : ERROR_COLOR
                                }}
                            />
                            <span style={{ fontSize: '0.9rem', color: '#1e293b', lineHeight: 1.4 }}>
                                <strong style={{ color: PRIMARY_BLUE }}>{id}</strong>{' '}
                                {th('pendingApprovalRequests.bulkClaimRow')}&nbsp;
                                <span style={{ color: isSuccess ? SUCCESS_COLOR : ERROR_COLOR, fontWeight: 600 }}>
                                    {message}
                                </span>
                            </span>
                        </li>
                    );
                })}
            </ul>
        </Dialog>
    );
};

export default BulkResultDialog;
